import { render, staticRenderFns } from "./IbLoginFeeReductionRewardEditor.vue?vue&type=template&id=1ecbb6ec&scoped=true"
import script from "./IbLoginFeeReductionRewardEditor.vue?vue&type=script&lang=ts"
export * from "./IbLoginFeeReductionRewardEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecbb6ec",
  null
  
)

export default component.exports